module.exports = __webpack_public_path__ + "img/plate-placeholder.8ce11a0e.jpg";